{
  "ascending": "rastući",
  "ascendingSort": "sortirano po kolonama {columnName} rastućim redosledom",
  "collapse": "Skupi",
  "columnSize": "{value} piksela",
  "descending": "padajući",
  "descendingSort": "sortirano po kolonama {columnName} padajućim redosledom",
  "expand": "Proširi",
  "resizerDescription": "Pritisnite Enter da biste započeli promenu veličine",
  "select": "Izaberite",
  "selectAll": "Izaberite sve",
  "sortable": "kolona koja se može sortirati"
}
